"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFullAddress = exports.generateAddressFieldValue = exports.getAddressFieldEmptyValue = void 0;
const getAddressFieldEmptyValue = () => {
    return {
        location_address: "",
        location_address2: "",
        location_zip: "",
        location_country: "",
        location_state: "",
        location_city: "",
        location_longitude: "",
        location_latitude: "",
        sys_root: "",
    };
};
exports.getAddressFieldEmptyValue = getAddressFieldEmptyValue;
const generateAddressFieldValue = (value) => {
    return { ...(0, exports.getAddressFieldEmptyValue)(), ...value };
};
exports.generateAddressFieldValue = generateAddressFieldValue;
const generateFullAddress = (value) => {
    const nestedSlugs = [
        "address",
        "address2",
        "city",
        "state",
        "zip",
        "country",
    ];
    const addressParts = nestedSlugs
        .map((addressPart) => value[addressPart])
        .filter((addressPart) => !!addressPart);
    return addressParts.join(", ");
};
exports.generateFullAddress = generateFullAddress;
